export const headingSize = "24px";
